import { render, staticRenderFns } from "./NewMessageButtonHeader.vue?vue&type=template&id=2d5c36ea&scoped=true"
import script from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
export * from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
import style0 from "./NewMessageButtonHeader.vue?vue&type=style&index=0&id=2d5c36ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c36ea",
  null
  
)

export default component.exports